<template>
  <div id="nav-wrapper" class="is-hidden">
    <container style="max-width: 1080px">
      <grid horizontal="center" vertical="middle">
        <grid-item :rwd="{ compact: '2/4' }">
          <img src="../../../public/img/logos/sg_logo.png" id="logo" />
        </grid-item>
        <grid-item size="2/5" id="sgz-nav-wrapper-title" class="text-center">
          <h1 id="title">
            Survivor GameZ<br />
            Closed Alpha
          </h1>
        </grid-item>
        <grid-item class="text-right" :rwd="{ compact: '2/4' }">
          <!--                    <sgz-button hide-alpha-text class="sgz-nav-btn" style="max-width: 200px"/>-->
        </grid-item>
      </grid>
    </container>
  </div>
</template>

<script>
import SgzButton from "./Button";

export default {
  name: "SgzNavigation",
  components: {
    SgzButton
  },
  methods: {
    checkPosition() {
      let scrollPos = 400;
      const nav = document.getElementById("nav-wrapper");

      let windowY = window.scrollY;
      if (windowY > scrollPos) {
        // Scrolling UP
        nav.classList.add("is-visible");
        nav.classList.remove("is-hidden");
      } else {
        // Scrolling DOWN
        nav.classList.add("is-hidden");
        nav.classList.remove("is-visible");
      }
      scrollPos = windowY;
    }
  },
  created() {
    window.addEventListener("scroll", this.checkPosition);
  }
};
</script>

<style lang="scss">
.hide-alpha-text {
  @media (max-width: 600px) {
    display: none !important;
  }
}
</style>

<style lang="scss" scoped>
@import "../../assets/styles/vars";

#nav-wrapper {
  background-image: linear-gradient(
    180deg,
    #000000 0%,
    #101010 37%,
    rgba(38, 38, 38, 0.73) 98%,
    rgba(38, 38, 38, 0) 100%
  );
  padding: 1em;
  position: sticky;
  top: 0;
  z-index: 1000;
  min-height: 80px;
  transition: transform 0.5s;

  &.is-visible {
    transform: translateY(0);
  }

  &.is-hidden {
    transform: translateY(-100%);
  }
}

#logo {
  max-width: 100%;
  height: auto;
  max-height: 102px;

  @media (max-width: 600px) {
    max-width: 70px;
  }

  @media (max-width: 500px) {
    max-width: 60px;
  }
}

#title {
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 4.04px;
  line-height: 1.5em;
  font-family: $metron;

  @media (max-width: 600px) {
    font-size: 11px;
    letter-spacing: 1px;
  }
}

#sgz-nav-wrapper-title {
  @media (max-width: 444px) {
    display: none;
  }
}

.sgz-nav-btn {
}
</style>
